// eslint-disable-next-line import/no-extraneous-dependencies
import {
    sendShopifyAnalytics,
    getClientBrowserParameters,
    AnalyticsEventName, 
} from "@shopify/hydrogen-react";

const analyticsShopData = {
    shopId: `gid://shopify/Shop/${process.env.GATSBY_SHOP_ID}`,
    currency: "USD",
    acceptedLanguage: "en",
};
// eslint-disable-next-line import/prefer-default-export
export const trackPageView = () => {
    const payload = {
        ...getClientBrowserParameters(),
        hasUserConsent: true,
        ...analyticsShopData,
    };

    sendShopifyAnalytics({
        eventName: AnalyticsEventName.PAGE_VIEW,
        payload,
    });
};
